export const GET_ROOT = 'GET_ROOT';
export const GET_MENUS = 'GET_MENUS';
export const LEAGUEID_DETAILS = 'LEAGUEID_DETAILS';
export const BUTTON_CONFIG = 'BUTTON_CONFIG'; // 菜单按钮
